import { GeneralStoreService } from './../../store/general.store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { EnvironmentSettings } from '../../models/environment-settings';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit, OnDestroy {
  public environmentSettings: EnvironmentSettings;
  private envSubscription: Subscription;

  constructor(
    private generalStoreService: GeneralStoreService
  ) { }

  ngOnInit(): void {
    this.envSubscription = this.generalStoreService.getEnvironmentSettings().subscribe(es => this.environmentSettings = es);
  }

  ngOnDestroy(): void {
    if (this.envSubscription) { this.envSubscription.unsubscribe(); }
  }

}
